var _ = require('underscore');
var sha1 = require('sha1');
var Fingerprint2 = require('fingerprintjs2')
var { error } = require('./error')
const ct = require("countries-and-timezones");

import f from './functions.js'
import Storage from './cryptoStorage.js'

var User = function ({
    vm,
    api,
    cordovakit,
    vueapi,
    i18n,
    sync
    
}, {prepare, clearing, core}) {

    var self = this
    var storage = null

    const salt = process.env.VUE_APP_SALT;
    const prefix = process.env.VUE_APP_PREFIX;
    const fingerPrintDefault = 'fingerPrintDefault';
    const lskey = 'defaultCryptoKey'

    var fcmNotification = null;

    var device = f.makeid()
    
    if(typeof localStorage != 'undefined'){
        if (localStorage['device']) 
            device = localStorage['device']

        localStorage['device'] = device;
    }

    var fingerprint = ''

    self.info = {}

    self.features = {}
    
    self.product = []

    self.setEnv = function({locale, timeZoneOffset}){
        self.locale = locale
        self.timeZoneOffset = timeZoneOffset

        if (vm.$store){

            vm.$store.commit('locale', core.settings.interface.get('interfacelocale').value == 'inherrit' ? self.locale : core.settings.interface.get('interfacelocale').value)
        }

    }

    self.setEnv({
        locale : (window.navigator.userLanguage || window.navigator.language || 'en-US').split('-')[0],
        timeZoneOffset : (new Date()).getTimezoneOffset()
    })

    self.link = function(payload){
        return api.user.link(payload).then(sdata => {

            pwdhash._value = sdata.pwdhash
            login._value = sdata.login

            return self.signin({
                pwdhash_value : sdata.pwdhash,
                login_value : sdata.login
            })

        })

        .then(() => {

            return state._value

        }).catch(e => {

            state._value = 0

            return Promise.reject(e)

        })
    }
    

    var verify = function(){

        return new Promise((resolve, reject) => {

            self.hasFaceid().then(() => {

                var resolved = false

                cordovakit.faceid.verify().then(code => {

                    if(resolved) return

                    if (vm.$store)
                        vm.$store.commit('CLOSE_MODAL', 'modal_pincode')

                    resolved = true

                    resolve(code)

                })

                vueapi.pincode('enter', 3, function(code){

                    var tempstorage = new Storage(code)
        
                    try{
                        tempstorage.getItem(prefix + '-token')
                        return Promise.resolve()
                    }
                    catch(e) {
                        return Promise.reject()
                    }
        
                }).then((code) => {

                    if(resolved) return

                    resolved = true

                    resolve(code)

                }).catch(e => {

                    reject(e)
                })

            }).catch(reject)

        })
        
    }

    var getstorage = function(){

        if(storage) return Promise.resolve(storage)


        return verify().catch(e => {
            return Promise.resolve(lskey)
        }).then(password => {

            if(typeof localStorage == 'undefined') {
                storage = {
                    setItem : () => {},
                    getItem : () => {},
                    removeItem : () => {},
                    clear : () => {}
                }
            }
            else{
                storage = new Storage(password)
            }

            return Promise.resolve(storage)

        }).catch(e => {
            return Promise.reject(e)
        })
    }

    var changestorage = function(){

        var lui = null
        if (storage) {

            try{
                lui = storage.getItem('ui')
            }catch(e){}
            

            storage.clear()
            storage = null
        }

        return getstorage().then( r => {
            return state.is()
        }).then(state => {

            if(state == 1){

                if (lui)
                    storage.setItem('ui', lui)

                login.save()
                token.save()
                //// set pwd to new storage
            }

        })
    }

    self.setfaceid = function(){

        return self.faceIdAvailable().then(() => {
            return state.is()
        }).then(state => {

            if (state != 1) return Promise.reject('unauthorized')

            return vueapi.pincode('create')

        }).then(code => {
            if (vm.$store)
                vm.$store.commit('globalpreloader', true)

            return cordovakit.faceid.set(code).then((r) =>{
                if (vm.$store)
                    vm.$store.commit('globalpreloader', false)
                return Promise.resolve(r)
            }).catch(e => {
                if (vm.$store)
                    vm.$store.commit('globalpreloader', false)
                return Promise.reject(e)
            })
        }).then(r => {
            return changestorage()
        })
    }

    self.deletefaceid = function(){

        return cordovakit.faceid.remove().then(r => {

            localStorage.removeItem('askedfaceid')

            return changestorage()
        }).catch(e => {
            console.error(e)

            return Promise.reject(e)
        })

    }

    self.hasFaceid = function(){
        return cordovakit.faceid.has()
    }

    self.faceIdAvailable = function(){
        return cordovakit.faceid.available()
    }

    self.askfaseid = function(){

        return cordovakit.faceid.available().then((type) => {

            return cordovakit.faceid.has().catch(e => {
                if (localStorage['askedfaceid']){
                    return Promise.resolve()
                }

                return vm.$dialog.confirm(
                    vm.$t('common.usefaceid_' + type), {
                    okText: vm.$t('yes'),
                    cancelText : vm.$t('no')
                })
        
                .then((dialog) => {

                    return self.setfaceid().then(r => {
                        return Promise.resolve()
                    }).catch(e => {
                        console.error('e', e)
                    })

                }).catch( e => {
                    localStorage['askedfaceid'] = true
                })


            })
            
        })
    }


    var state = {

        _value: -1,

        set value(v) {

            this._value = v;
            if (vm.$store)
                vm.$store.commit('auth', this.value)
        },

        get value() {
            return this._value
        },

        is: function () {

            switch (this._value) {
                case -1:

                    if(!token.check()){
                        this.value = 0;
                        return Promise.resolve(this.value)
                    }
                    
                    return getstorage().then(() => {
                        pwdhash.init()
                        token.init()
                        login.init()

                        if ((login.value && pwdhash.value) || token.value) {

                            return signin({

                                pwdhash_value: pwdhash.value,
                                login_value: login.value,
                                token_value: token.value

                            }).catch(e => {
                                return Promise.resolve(state.value)
                            })

                        }
                        else {
                            this.value = 0;

                            return Promise.resolve(this.value)
                        }

                        
                    }).catch(e => {
                        console.error('e', e)
                        this.value = 0;

                        return Promise.resolve(this.value)
                    })

                    break;

                case 0:
                case 1:
                    return Promise.resolve(this.value)

                case 2:

                    var t = this

                    return new Promise((resolve, reject) => {

                        setTimeout(function () {
                            resolve()
                        }, 50)

                    }).then(function () {
                        return t.is()
                    })

                default:
                    this.value = -1;

                    return this.is()
            }
        }

    };

    var pwdhash = {
        _value: "",
        get value() {
            return this._value
        },
        set value(v) {
            if (v) {

                this._value = v;
            }
            else {

            }
        },

        init: function () {

        }
    };

    var login = {
        _value: "",

        get value() {
            return this._value
        },

        set value(v) {
            if (v) {

                this._value = v;

                this.save()

            }

            else {
                storage.removeItem(prefix + '-login');
            }
        },

        init: function () {
            this._value = storage.getItem(prefix + '-login') || "";
        },

        save : function(){
            if (this._value)
                storage.setItem(prefix + '-login', this._value);
        }
    };

    var token = {
        _value: "",
        get value() {
            return this._value
        },
        set value(v) {

            if (v) {

                this._value = v;
                storage.setItem(prefix + '-token', v);

            }
            else {

                this._value = ''
                storage.removeItem(prefix + '-token');

            }

        },

        save : function(){
            if (this._value)
                storage.setItem(prefix + '-token', this._value);
        },

        init: function () {
            this._value = storage.getItem(prefix + '-token') || "";
        },

        check : function(){
            return localStorage.getItem(prefix + '-token') || "";
        }
    };

    function crypt(password) {
        return sha1(password + salt)
    }

    function startFcm() {
        if (typeof window != 'undefined' && window.cordova) {

            var settoken = function () {
                FirebasePlugin.getToken(function (fcmToken) {

                    if (!localStorage[prefix + '-fcm3'] || localStorage[prefix + '-fcm3'] !== fcmToken) {

                        api.notifications.register({ token : fcmToken, device }).then(r => {
                            localStorage[prefix + '-fcm3'] = fcmToken;
                        })

                    }

                }, function (error) {
                });

                var channel = {
                    id: "my_channel_id",
                    sound: 'ringtone',
                    vibration: [500, 200, 500],
                    light: true,
                    lightColor: parseInt("FF0000FF", 16).toString(),
                    importance: 4,
                    badge: false,
                    visibility: 1
                };

                FirebasePlugin.createChannel(channel,

                    function () {
                    },
                    function (error) {
                    });
            }

            if (!fcmNotification) {

                FirebasePlugin.hasPermission(function (hasPermission) {

                    if (!hasPermission) {
                        FirebasePlugin.grantPermission(function (hasPermission) {

                            if (hasPermission) {
                                settoken()
                            }

                        });
                    }
                    else {
                        settoken()
                    }

                });

                fcmNotification = FirebasePlugin.onMessageReceived((payload) => {
                    //
                });
            }

        } else {

        }
    }

    function extendA({ headers, data, system, formData }) {


        var extendedobj = data

        /*data.fingerprint = fingerprint
        data.device = device*/

        if (state.value != 1) {
            return Promise.resolve({ headers, data, system })
        }

        if (token.value) {

            if (extendedobj)
                extendedobj.jwt = token.value

            if (formData){
                formData.append('jwt', token.value)
            }
        }

        else {
            if (extendedobj){
                if (login.value) extendedobj.login = login.value
                if (pwdhash.value) extendedobj.pwdhash = pwdhash.value
            }
            
        }
        if (extendedobj){
            extendedobj.fingerPrint = fingerprint
        }

        if (formData){
            formData.append('fingerPrint', fingerprint)
        }

        return Promise.resolve({ headers, data, system })
    }

    function extendU(data, system) {

        if (state.value > 0) {
            (data.jwt || data.new_token || data.token || data.Token) ? token.value = (data.jwt || data.new_token || data.token || data.Token) : '';
        }
    }

    function setFingerPrint() {

        if (typeof window != 'undefined') {

            if (!fingerprint) {

                fingerprint = localStorage['fingerprint'] || ''

                if (!fingerprint) {

                    return Fingerprint2.getPromise({}).then(function (components) {

                        var values = components.map(function (component) { return component.value })
                        fingerprint = Fingerprint2.x64hash128(values.join(''), 31)

                        localStorage['fingerprint'] = fingerprint

                        return Promise.resolve(fingerprint)
                    })

                }

            }

        }

        return Promise.resolve(fingerprint || fingerPrintDefault)

    }

    function signout() {

        var prs = [self.deletefaceid()]

        if (typeof window != 'undefined' && window.cordova)
            prs.push(api.notifications.revoke({ device }).then(r => {
                localStorage.removeItem(prefix + '-fcm3')

                return Promise.resolve()
            }).catch(e => {
                return Promise.resolve()
            }))

        if (vm.$store)
            vm.$store.commit('globalpreloader', true)

        return Promise.all(prs).catch(e => {
            return Promise.resolve()
        }).then(r => {

            clear()

        }).finally(() => {
            if (vm.$store)
                vm.$store.commit('globalpreloader', false)
        })

    }


    function clear() {

        clearing()

        core.off('synk', 'user')

        sync.destroy()

        if (storage)
            storage.removeItem('ui')

        state.value = 0
        pwdhash.value = ''
        login.value = ''
        token.value = ''

        self.info = {}
        features()

       
    }


    function signup(data = {}, type){
        if(!data.login || !data.password) return Promise.reject('emptydata')

        data.info = {
            timezone : self.timeZoneOffset, 
            locale : self.locale
        }

        if(type) data.info.type = 4


        var tzc = ct.getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);

        if (tzc && tzc.id){
            data.info.countrycode = tzc.id.toLowerCase()
        }


        data.pwdhash = crypt(data.password)

        return api.user.register(data).then(r => {

            return signin({
                password_value : data.password,
                login_value : data.login
            })
        })
    }

    var features = function(info = {}){

        ///TODO

        self.features = {}

        _.each(info.Licenses, (l) => {
            if(l.ProductCode){
                self.features[l.ProductCode] = {
                    permissions : l.Permissions,
                    to : l.ValidTo,
                    full : _.find(l.Permissions || [], function(v){
                        return v.Code == 'LIGHT_MODE'
                    }) ? false : true
                }

                self.features[l.ProductCode].valid = f.date.nowUtc1000() < self.features[l.ProductCode].to / 1000

                
            }
        })

        if (vm.$store)
            vm.$store.commit('features', self.features)

    }

  

    self.checkFeatures = function(features, permission){

        if(!features) return true

        if(!self.info?.features) return false

        var f = _.find(features, (f) => {

            return _.find(self.info.features, (ff) => {
                return f == ff.name || f == ff.id
            })
        })
        
        if(!f){
            f = cordovakit.purchases.checkFeatures(features)
        }
        
        return f ? true : false
    }

    self.extendByFeatures = function(items){

        return _.filter(items, (item) => {

            return self.checkFeatures(item.features)

        })

    }

    self.extendByFeaturesMenu = function(menu, nolicense){
        var fs = _.filter(menu, (item) => {
            return self.checkFeatures(item.features)
        })

        return fs
    }

    function signin({
        password_value,
        login_value,
        pwdhash_value,
        token_value
    }) {

        var en = false

        var data = {}

        //clearSignin()

        if (vm.$store)
            vm.$store.commit('globalpreloader', true)

        return getstorage().then(() => {
            return setFingerPrint()
        }).then(fp => {

            fingerprint = fp

            if (((password_value || pwdhash_value) && login_value) || token_value) {

                if (token_value) {
                    data.jwt = token_value
                }
                else {
                    data.pwdhash = pwdhash_value || crypt(password_value)
                    data.login = login_value
                }

                data.fingerPrint = fingerprint


                en = true;
            }

            if (en) {
                state.value = 2

                return api.user.signin(data).catch(e => {

                    if((!e.code || e.code != 401) && data.jwt){
                        var altinfo = storage.getItem('ui')

                        if (altinfo){
                            return Promise.resolve(altinfo)
                        }
                    }

                    return Promise.reject(e)
                })
            }

            state.value = 0

            return Promise.reject(error(511))

        }).then(result => {

            try {
                startFcm();
            } catch (e) { 

                console.error('e', e)
            }

            state.value = 1

            pwdhash.value = data.password
            login.value = data.login

            self.setUserInfo(result)

            //delete self.info.userinfo.bday

            features(result)

            storage.setItem('ui', result)

            if (vm.$store)
                vm.$store.commit('userinfo', self.info)

            //settings.getall()

            sync.init(self)
                
            prepare(this)

        }).then(() => {

            if (vm.$store)
                vm.$store.commit('globalpreloader', false)

            return state.value

        }).catch(e => {

            console.error(e)

            if (vm.$store)
                vm.$store.commit('globalpreloader', false)


            state.value = 0

            return Promise.reject(e)
        })
    }

    var prepareUserInfo = function(info = {}){
        if (info.userinfo){

            if (info.userinfo.bday) {
                info.userinfo.bday = new Date(info.userinfo.bday)
                info.userinfo.age = f.calculateAge(info.userinfo.bday)
            }

            if(info.userinfo.userpicture) info.userinfo.image = api.kit.file(info.userinfo.userpicture, 'users_picture', 'small') 
        }

        
    
        return info
    }

    self.setUserInfo = function(info){
        if(!info) return

        self.info = prepareUserInfo({...self.info, ...info})

        if (vm.$store){

            vm.$store.commit('userinfo', self.info)
        }

        if (info.features){
            vm.$store.commit('successCDVpayment', false)
        }

        self.applyEnv()
    }

    self.cdvOwned = function(plan){
        console.log('cdvOwned', plan)

        /*self.setUserInfo({
            cdvOwned : plan
        })*/
    }

    self.applyEnv = function(){
        self.setEnv({
            locale : self.info.userinfo.locale,
            timeZoneOffset : self.info.userinfo.timezone
        })
    }

    self.checkInfo = function(){

        if(self.info?.userinfo.type) return null

        var availableLocales = f.deep(core, 'appInfo.snippity.settings.locales') || []

        if (availableLocales.indexOf(self.locale) == -1) return 'locale'

        //self.locale

        var bday = self.info?.userinfo?.bday

        if(!bday) return 'bday'

        return null
    }

    self.infoEdit = function(data){
        return api.user.infoEdit(data).then((result) => {

            //self.info.userinfo = {...self.info.userinfo, ...data.info}

            var info = {...self.info.userinfo, ...data.info}

            self.setUserInfo({userinfo : info})

            return Promise.resolve()
        }).catch(e => {
            console.error(e)

            return Promise.reject(e)
        })
    }


    self.init = function(){
        self.inited = true

        core.on('synk', 'user', ({data, id, date}) => {

            if(self.info.userinfo && data.userinfo && !_.isEmpty(data.userinfo)){
                self.setUserInfo({userinfo : data.userinfo })
            }

            if(self.info.features && data.features && !_.isEmpty(data.features)){
                self.setUserInfo({features : data.features})
            }

        })
    }

    self.changePassword = function(pwd){
        pwd = crypt(pwd)

        return api.account.password.change(pwd).then(result => {

            if (result.data.changed)

                pwdhash._value = pwd

            return Promise.resolve(result.data)

        })
    }

    self.checkPassword = function(pwd){
        return crypt(pwd) == pwdhash._value
    }


    self.api = {
    }

    self.state = state

    self.extendA = extendA
    self.extendU = extendU

    self.signin = signin
    self.signup = signup
    self.signout = signout

    self.crypt = crypt


    self.id = function(){
        return state.is().then(state => {

            var id = self.info?.userinfo?.id

            if (id) {
                return Promise.resolve(id)
            }

            return Promise.reject('info')
        })
    }

    self.getinfo = function(){
        return state.is().then(state => {
            if(self.info) {
                return Promise.resolve(self.info)
            }
        })
    }



    return self

}



export default User